import { createContext, useContext, useMemo, useState } from 'react';

const IntakeFormContext = createContext({});

export const useIntakeFormContext = () => useContext(IntakeFormContext);

export const IntakeFormContextProvider = (props) => {
  const [practiceAreaList, setPracticeAreaList] = useState([]);
  const [roles, setRoles] = useState([]);
  const [contactList, setContactList] = useState([]);
  const [contactCustomFields, setContactCustomFields] = useState([]);

  const contextPayload = useMemo(
    () => ({
      practiceAreaList,
      setPracticeAreaList,
      roles,
      setRoles,
      contactList,
      setContactList,
      contactCustomFields,
      setContactCustomFields,
    }),
    [practiceAreaList, roles, contactList, contactCustomFields]
  );

  return <IntakeFormContext.Provider value={contextPayload} {...props} />;
};
